export default "__VITE_ASSET__b4240698__"